import AppHeader from "components/appHeader/AppHeader";
import RootLayout from "components/root_layout/rootLayout";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { isAuth, isSanwaAdmin } from "utils";

const PublicLayout = ({ children }) => {
  if (isAuth()) {
    return (
      <Redirect
        to={isSanwaAdmin() ? ROUTE.ADMIN.PATIENTS : ROUTE.CLINIC.PATIENT}
      />
    );
  }

  return <RootLayout header={<AppHeader />} content={children} />;
};

export default PublicLayout;
